module.exports = __webpack_public_path__ + "img/approval_t.27e3c429.png";